import { delay, call, put, select, takeEvery } from 'redux-saga/effects';
import * as filtersActions from '../../actions/filters/filters';
import { getAllFiltersRequest } from '../../../api/filters/getAllFiltersRequest';
import { getProfileFiltersRequest } from '../../../api/filters/getProfileFiltersRequest';
import { updateProfileFiltersRequest } from '../../../api/filters/updateProfileFiltersRequest';
import { setActiveProfile } from '../../../../Authorization/redux/actions/ProfileList';
import { successUpdateProfileFilters } from '../../../components/MyFilters/popup/success';
import showSuccessWindow from '../../../../../common/components/successPopup/successPopup';

import history from '../../../../../common/history';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllFiltersSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getAllFiltersRequest);
      yield put(filtersActions.getAllFiltersSuccess(response));
    } catch (e) {
      yield put(filtersActions.getAllFiltersFailure(e));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(filtersActions.getAllFilters(action.payload))
      : history.push('/authorization/profiles');
  }
}

function* getProfileFiltersSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getProfileFiltersRequest, activeProfileId);
      yield put(filtersActions.getProfileFiltersSuccess(response));
    } catch (e) {
      yield put(filtersActions.getProfileFiltersFailure(e));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(filtersActions.getProfileFilters(action.payload))
      : history.push('/authorization/profiles');
  }
}

function* updateProfileFiltersSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        updateProfileFiltersRequest,
        activeProfileId,
        action.payload
      );
      yield put(filtersActions.updateProfileFiltersSuccess(response));
      showSuccessWindow(successUpdateProfileFilters);
    } catch (e) {
      yield put(filtersActions.updateProfileFiltersFailure(e));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(filtersActions.updateProfileFilters(action.payload))
      : history.push('/authorization/profiles');
  }
}
/* при смене на новый профиль очищаем загруженные настройки фильтров для старого профиля */
function* clearProfileFiltersSaga(action) {
  const profileFilters = yield select(state => {
    return (
      state.SystemSettings &&
      state.SystemSettings.filters &&
      state.SystemSettings.filters.profileFilters
    );
  });
  if (profileFilters) {
    yield put(filtersActions.clearProfileFilters());
  }
}

export function* filtersWatcher() {
  yield takeEvery(filtersActions.getAllFilters.toString(), getAllFiltersSaga);
  yield takeEvery(
    filtersActions.getProfileFilters.toString(),
    getProfileFiltersSaga
  );
  yield takeEvery(
    filtersActions.updateProfileFilters.toString(),
    updateProfileFiltersSaga
  );
  yield takeEvery(setActiveProfile.toString(), clearProfileFiltersSaga);
}
